import React from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { OfflineProvider } from "@/offline/OfflineProvider";

/**
 * AppShell — Phoenix root layout for authenticated module screens.
 *
 * Pattern:
 *   <ProtectedRoute>
 *     <AppShell />
 *   </ProtectedRoute>
 *
 * Nested routes render into <Outlet/>. The shell owns:
 *   - permission-aware sidebar
 *   - universal search + user menu in the topbar
 *   - the content canvas
 *
 * Existing Dashboard/Inventory pages still live outside AppShell for
 * backwards compatibility (Sprint 10 foundation only). Migration into
 * AppShell is scheduled for Sprint 10.2 and later.
 */
export function AppShell({ testid = "app-shell" }) {
  return (
    <OfflineProvider>
    <div
      data-testid={testid}
      className="min-h-screen flex bg-[var(--phx-brand-canvas)] text-slate-900"
      style={{ fontFamily: "var(--phx-font-sans)" }}
    >
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Topbar />
        <main className="flex-1 px-6 sm:px-10 py-8 max-w-7xl w-full mx-auto">
          <Outlet />
        </main>
      </div>
    </div>
    </OfflineProvider>
  );
}
